import { render, staticRenderFns } from "./procurementAccount.vue?vue&type=template&id=67ca42d6&"
import script from "./procurementAccount.vue?vue&type=script&lang=js&"
export * from "./procurementAccount.vue?vue&type=script&lang=js&"
import style0 from "./procurementAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports